module.exports = __webpack_public_path__ + "img/vacancy-list-error-bg.ed0715af.svg";